<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.ALI.database.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:relationalDatabaseServiceResourceGcp:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:relationalDatabaseServiceResourceGcp:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <relational-database-service-resource-gcp-search
      ref="child"
    ></relational-database-service-resource-gcp-search>
    <table-relational-database-service-resource-gcp></table-relational-database-service-resource-gcp>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import RelationalDatabaseServiceResourceGcpSearch from "../rds/RelationalDatabaseServiceResourceGcpSearch";
import TableRelationalDatabaseServiceResourceGcp from "../rds/TableRelationalDatabaseServiceResourceGcp";
import Export from "../../gcp/Export.vue";
export default {
  name: "RelationalDatabaseServiceResourceGcp",
  components: {
    RelationalDatabaseServiceResourceGcpSearch,
    TableRelationalDatabaseServiceResourceGcp,
    Export
  },
  data() {
    return {
      modal_loading: false,
      loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          resourceManagement: 1,
          accountType: 4
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        companyId: this.$refs.child.companyId,
        accountName: this.$refs.child.accountNameSearchKey,
        name: this.$refs.child.name
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportGCPCloudSQL(exportDTO).then(res => {
        let fileName = this.$t('RAM.export.database');
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t('common.exportSuccess'));
      });
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/rds/RelationalDatabaseServiceResourceGcp.vue